/**
 * Constants for RiseAI Chat component
 */

export const DRAWER_WIDTH = '1200px';

export const CATEGORIES = ['All', 'Vulnerabilities', 'SBOM', 'Licenses', 'Cryptography', 'Binaries', 'Secrets'];

export const RISE_AI_APP_NAME = 'rise_ai_llm_agent';
